module.exports = __webpack_public_path__ + "static/img/homecenter.ff0ea2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/homecenter.png
// module id = 8byk
// module chunks = 44